import React from "react";


function Footer({textColor}) {
  return (
      <footer className="text-center text-xs p-3 fixed-bottom w-full" style={{backgroundColor: "transparent", color: textColor, zIndex: 0}}>
        &copy; Copyright Steven Yao 2020 - 2022
      </footer>
  );
}

export default Footer;
